/**
 * An error that represents an error HTTP status code response.
 */
export class HttpStatusCodeError extends Error {
  constructor(reason: string, status: number) {
    super(`Http Status error code ${status}: ${reason}`);
  }
}
